import React from "react";
import html from "../../assets/icons/html.png";
import css from "../../assets/icons/css.png";
import javascript from "../../assets/icons/javascript.png";
import react from "../../assets/icons/react.png";
import tailwind from "../../assets/icons/tailwind.png";
import node from "../../assets/icons/node.png";
import github from "../../assets/icons/github.png";
import nextjs from "../../assets/icons/nextjs.png";
import chakra from "../../assets/icons/chakra.png";
import git from "../../assets/icons/git2.png";
import typescript from "../../assets/icons/typescript.jpg";
import Title from "../layouts/Title";

const MyExperience = () => {
  const techStack = [
    { id: 1, src: html, title: "HTML", style: "shadow-orange-500" },
    { id: 2, src: css, title: "CSS", style: "shadow-blue-500" },
    { id: 3, src: javascript, title: "JavaScript", style: "shadow-yellow-500" },
    { id: 4, src: node, title: "Node.js", style: "shadow-green-500" },
    { id: 5, src: react, title: "React.js", style: "shadow-slate-600" },
    { id: 6, src: nextjs, title: "Next.js", style: "shadow-white" },
    { id: 7, src: typescript, title: "TypeScript", style: "shadow-sky-600" },
    { id: 8, src: tailwind, title: "Tailwind", style: "shadow-teal-500" },
    { id: 9, src: chakra, title: "Chakra UI", style: "shadow-teal-700" },
    { id: 10, src: git, title: "Git", style: "shadow-orange-600" },
    { id: 11, src: github, title: "Github", style: "shadow-teal-700" },
  ];

  return (
    <div className="wrapper min-w-fit mx-auto  px-5 ">
      <section id="experience">
        <div className="w-full md:text-left text-center pt-20">
          <div className="flex flex-col justify-center w-full text-white">
            <div>
            <Title title="Skills" des="Experience" />
              <p className="py-6">These are the technologies I have worked with</p>
            </div>
            <div className="w-full grid md:justify-center sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 text-center">
              {techStack.map(({ id, src, title, style }) => (
                <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg z-10 ${style}`}>
                  <img src={src} alt={title} className="w-24 mx-auto" />
                  <p className="mt-4">{title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyExperience;
